
import { gql } from '@apollo/client';

export const LOCATION_BY_GOOGLE_PLACE_ID = gql`
  query LocationByGooglePlaceId($id: String!) {
    locationByGooglePlaceId(id: $id) {
      id
      hub
      address {
        formattedAddress
        countryCode
        originalAddress
      }
      position {
        lat
        lng
      }
    }
  }
`;
